import { render, staticRenderFns } from "./InspectionRecordsDetails.vue?vue&type=template&id=c8fe3eca&"
import script from "./InspectionRecordsDetails.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports